import React from 'react';

import css from './prayer-pre-text.module.scss';

interface Props {
  ref: React.RefObject<HTMLDivElement>;
}
export const PrayerPreText: React.FC<Props> = ({ ref }) => {
  return (
    <div ref={ref} className={css.prayerPreText}>
      התפילה שאתה עומד לבקש פותחת דלתות שנסגרו מזמן
    </div>
  );
};
